<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button menu="root-menu" />
    </ion-buttons>
    <ion-title>{{ 'SETTINGS.SETTINGS' | translate }}</ion-title>
    <ion-buttons slot="end">
      <i class="icon-settings header-icon"></i>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    @if (currentLanguage() === 'da' || currentLanguage() === 'en') {
      <ion-nav-link router-direction="forward" [component]="selectTargetGroupPage">
        <ion-item button detail="true">
          <ion-label>
            <h2>{{ 'SETTINGS.TARGET_GROUP' | translate }}</h2>
            <p>
              {{
                'INTRO.' + (!targetGroup() || targetGroup() === 'pre-existing' ? 'PRE_EXISTING' : 'GESTATIONAL')
                  | translate
              }}
            </p>
          </ion-label>
        </ion-item>
      </ion-nav-link>
    }
    <ion-nav-link router-direction="forward" [component]="selectLanguagePage">
      <ion-item button detail="true">
        <ion-label>
          <h2>{{ 'SETTINGS.LANGUAGE' | translate }}</h2>
          <p>{{ 'SETTINGS.' + currentLanguage() | uppercase | translate }}</p>
        </ion-label>
      </ion-item>
    </ion-nav-link>
    @if (currentLanguage() === 'da') {
      <ion-nav-link router-direction="forward" [component]="selectTreatmentPlacePage">
        <ion-item button detail="true">
          <ion-label>
            <h2>{{ 'SETTINGS.TREATMENT_PLACE' | translate }}</h2>
            <p>{{ 'SETTINGS.' + currentTreatmentPlace() | uppercase | translate }}</p>
          </ion-label>
        </ion-item>
      </ion-nav-link>
    }
  </ion-list>
</ion-content>
